import api from './api';

export default async function updateArcAutomarkerQuestion(task_id) {
  const { data } = await api.put(`arc-automarker/questions/${task_id}`);
  return data;
}